// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../reason/next/Next.bs.js");
let Utils = require("../../utils/Utils.bs.js");
let IconV5 = require("../common/Components/IconV5.bs.js");
let Link = require("next/link").default;
let FeaturesV3 = require("../../reason/featureFlipper/FeaturesV3.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let SettingsPageSidebarQuery_graphql = require("../../__generated__/SettingsPageSidebarQuery_graphql.bs.js");

function SettingsPageSidebar$SidebarLink(props) {
  let __childLinks = props.childLinks;
  let url = props.url;
  let name = props.name;
  let childLinks = __childLinks !== undefined ? __childLinks : [];
  let router = Next.useRouter();
  let query = Next.Router.query(router);
  let __x = Stdlib_Option.getOr(query["setting"], []);
  let currentSettingPath = Utils.$$Array.joinWith("/", __x);
  let currentPath = `/account/` + currentSettingPath;
  let current = currentPath === url;
  if (childLinks.length === 0) {
    return JsxRuntime.jsx(Link, {
      href: url,
      passHref: true,
      className: TailwindMerge.twMerge([
        current ? "bg-zinc-50 text-zinc-900 hover:text-zinc-900 focus:text-zinc-900" : "hover:bg-zinc-50 hover:text-zinc-900 text-zinc-700",
        "flex rounded-md p-2 text-base leading-6 font-semibold "
      ]),
      children: name
    });
  }
  let isOpen = currentPath.startsWith(url);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(Link, {
        href: url,
        className: TailwindMerge.twMerge([
          current ? "bg-zinc-50 text-zinc-900 hover:text-zinc-900 focus:text-zinc-900" : "hover:bg-zinc-50 hover:text-zinc-900 text-zinc-700",
          "flex items-center rounded-md p-2 text-base leading-6 font-semibold"
        ]),
        children: [
          name,
          JsxRuntime.jsx(IconV5.make, {
            icon: "arrow-right",
            className: TailwindMerge.twMerge([
              isOpen ? "rotate-90 text-zinc-500" : "text-zinc-400",
              "ml-auto h-4 w-4 shrink-0"
            ])
          })
        ]
      }),
      isOpen ? JsxRuntime.jsx("ul", {
          children: childLinks.map(childLink => {
            let isCurrent = currentPath === childLink.url;
            return JsxRuntime.jsx("li", {
              children: JsxRuntime.jsxs(Link, {
                href: childLink.url,
                className: TailwindMerge.twMerge([
                  isCurrent ? "bg-zinc-50 text-zinc-900 hover:text-zinc-900 focus:text-zinc-900 font-semibold" : "hover:bg-zinc-50 hover:text-zinc-900 text-zinc-700",
                  "block rounded-md py-2 pr-2 pl-9 text-base leading-6 "
                ]),
                children: [
                  JsxRuntime.jsx("span", {
                    children: name + ` - `,
                    className: "sr-only"
                  }),
                  childLink.name
                ]
              })
            }, childLink.name);
          }),
          className: "mt-1 px-2"
        }) : null
    ]
  });
}

let SidebarLink = {
  make: SettingsPageSidebar$SidebarLink
};

let convertVariables = SettingsPageSidebarQuery_graphql.Internal.convertVariables;

let convertResponse = SettingsPageSidebarQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = SettingsPageSidebarQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, SettingsPageSidebarQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, SettingsPageSidebarQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(SettingsPageSidebarQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(SettingsPageSidebarQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(SettingsPageSidebarQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(SettingsPageSidebarQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function SettingsPageSidebar$MarketingProfileSidebarLinks(props) {
  let match = use(undefined, undefined, undefined, undefined);
  let subpages = MarketingProfileSubpages.useSubpagesForCurrentAccount(Stdlib_Option.map(match.currentAccountV5.marketingProfile, x => x.fragmentRefs));
  if (subpages !== undefined) {
    if (subpages.TAG === "AgentPages") {
      return JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
        name: "Marketing Profile",
        url: "/account/marketing_profile",
        childLinks: subpages._0.map(page => ({
          name: page.displayName,
          url: page.path
        }))
      });
    } else {
      return JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
        name: "Team Marketing Profile",
        url: "/account/team_marketing_profile",
        childLinks: subpages._0.map(page => ({
          name: page.displayName,
          url: page.path
        }))
      });
    }
  } else {
    return JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
      name: "Marketing Profile",
      url: "/account/marketing_profile"
    });
  }
}

let MarketingProfileSidebarLinks = {
  make: SettingsPageSidebar$MarketingProfileSidebarLinks
};

function SettingsPageSidebar(props) {
  let marketingProfileSettingsEnabled = FeaturesV3.useFeatureFlipper("MarketingProfileSettings") === "on";
  let billingPageEnabled = UserSession.useChapterPreference("PayingChapter") === "ON";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
        name: "TAN Profile",
        url: "/account/profile"
      }),
      JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
        name: "Preferences",
        url: "/account/preferences"
      }),
      JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
        name: "Password",
        url: "/account/password"
      }),
      JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
        name: "Email Notifications",
        url: "/account/email_notifications"
      }),
      JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
        name: "Account Users",
        url: "/account/users"
      }),
      billingPageEnabled ? JsxRuntime.jsx(SettingsPageSidebar$SidebarLink, {
          name: "Billing",
          url: "/account/billing"
        }) : null,
      marketingProfileSettingsEnabled ? JsxRuntime.jsx(SettingsPageSidebar$MarketingProfileSidebarLinks, {}) : null
    ],
    className: "bg-white space-y-1 p-3 rounded shadow-sm"
  });
}

let make = SettingsPageSidebar;

exports.SidebarLink = SidebarLink;
exports.Query = Query;
exports.MarketingProfileSidebarLinks = MarketingProfileSidebarLinks;
exports.make = make;
/* use Not a pure module */
